import { selectCurrentCourse, selectGroupedWeeklySchedule } from '../../../db/courses/selectors';
import { useAppSelector } from '../../../store/hooks';

export default function useCreateCoursePreviewVM() {
  const currentCourse = useAppSelector((state) => selectCurrentCourse(state));
  const weeklySchedule = useAppSelector((state) => selectGroupedWeeklySchedule(state));
  const timezone = currentCourse?.schedule.timezone || '';
  return { timezone, weeklySchedule };
}
